if (!customElements.get('addon-product')) {
  class AddonProduct extends HTMLElement {
    selectors = {
      wrapper: 'data-island.bundle-product',
      addButton: '[data-add-button]',
    };

    constructor() {
      super();

      this.productId = this.getAttribute('data-product-id');
      this.variantId = this.getAttribute('data-variant-id');
      this.price = this.getAttribute('data-price');
      this.discountedPrice = this.getAttribute('data-discounted-price');
      this.title = this.getAttribute('data-title');
      this.isFixedAddon = this.getAttribute('data-is-fixed-addon') === 'true';
      this.handleOnLoad = this.handleOnLoad.bind(this);
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.isFixedAddon = this.getAttribute('data-is-fixed-addon') === 'true';

      this.wrapper = this.closest(this.selectors.wrapper);
      if (!this.wrapper) {
        console.error('No wrapper found for bundle card');
      }
      this.cacheElements();
      if (this.isFixedAddon) {
        this.handleOnLoad();
      } else {
        this.addListeners();
      }
    }

    /**
     * Get bundle data.
     *
     * @returns {Object}
     */
    getBundleData() {
      return {
        title: this.title,
        productId: this.productId,
        variantId: this.variantId,
        price: Number(this.price),
        discountedPrice: Number(this.discountedPrice) || Number(this.price),
      };
    }

    handleOnLoad() {
      if (this.wrapper) {
        const bundleComponent = this.wrapper.querySelector('bundle-product');
        
        if (bundleComponent) {
          const bundleTag = bundleComponent.tagName.toLowerCase();
          customElements.whenDefined(bundleTag).then(() => {
            this.handleDispatchedEvent();
          });
        } else {
          requestAnimationFrame(() => {
            this.handleDispatchedEvent();
          });
        }
      }
    }

    /**
     * Add listeners.
     */
    addListeners() {
      this.addButton.addEventListener('change', this.onButtonClick.bind(this));
    }

    /**
     * Cache elements.
     *
     * @returns {Void}
     */
    cacheElements() {
      this.addButton = this.querySelector(this.selectors.addButton);

      if (!this.addButton) {
        console.error('Missing elements in bundle card');
        return;
      }
    }

    /**
     * On button click.
     *
     * @param {Event} event
     * @returns {Void}
     */
    onButtonClick(event) {
      this.classList.toggle('is-selected', event.target.checked);
      this.handleDispatchedEvent();
    }

    handleDispatchedEvent() {
      const customEvent = new CustomEvent('bundle:addon:update', {
        bubbles: true,
      });
      this.dispatchEvent(customEvent);
    }
  }
  customElements.define('addon-product', AddonProduct);
}
